/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'gatsby';
import React from 'react';
import links from '../../data/links.json';
import products from '../../data/products.json';
import FreshWorks from '../Common/Freshworks';
import Item from './ItemMobile';

const Mobile = ({ isProduct = false, setMenuOpen }) => {
  return (
    <div className="absolute top-2 inset-x-0 p-2 transition transform origin-top-right md:hidden z-20">
      <div className="rounded-lg shadow-md">
        <div
          className="rounded-lg bg-white shadow-xs overflow-hidden"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="main-menu"
        >
          <div className="px-5 pt-4 flex items-center justify-between">
            <div>
              <Link to="/" className="text-indigo-600 ">
                <svg
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </Link>
            </div>
            <div className="-mr-2">
              <button
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out bg-gray-50"
                aria-label="Close menu"
                onClick={() => setMenuOpen(false)}
              >
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="px-2 pt-2 pb-3">
            {isProduct ? (
              <>
                <Item link="#features" title="Explore Features" isTop />
                <Item link="#pricing" title="Pricing" />
                <Item link="#faq" title="Common Questions" />
              </>
            ) : (
              <>
                <Item link={products.GA01.link} title="Gmail Mail Merge" />
                <Item link={products.GA16.link} title="Document Studio" />
                <Item link={products.GA08.link} title="Form Notifications" />
              </>
            )}
            <Item link={links.BLOG} title="Technology Blog" />
            <Item link={links.DEVELOPER} title="Google Developer" />
          </div>
          <div>
            <FreshWorks
              className="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100 hover:text-indigo-700 focus:outline-none focus:bg-gray-100 focus:text-indigo-700 transition duration-150 ease-in-out"
              title="Contact Tech Support"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
